<template lang="pug">
div
  navbar(back="collection")
  div.row.q-pb-lg
    .offset-lg-2.col-lg-8.offset-md-1.col-md-10.offset-sm-0.col-sm-12
      oarepo-quasar-item(:collection-code='collectionCode', :item-id='itemId.toString()', ref="oarepo" @dataLoaded="dataLoaded")
        template(v-slot:title='{ item }')
          span
        template(v-slot:raw-content='{ item }')
          .row.items-baseline.justify-between.q-mt-md(v-if="item && item.metadata")
            .col-auto.q-pl-lg.q-pl-md-md.q-pl-sm-sm.q-pl-xs-xs.title-header
              kv(label="" :item="item.metadata" path="title" :edit="edit" type="item-name")
            .col-3
              h3.item-idlabel.text-weight-thin.float-right # {{ item.id }}
          .row.q-mt-md(v-if="item && item.metadata")
            .col-12.q-pl-lg.q-pl-md-md.q-pl-sm-sm.q-pl-xs-xs.title-header
              .float-right(v-if="item.metadata.submissionStatus === 'incomplete'")
                q-btn(flat color="positive" @click="requestReview(item)" icon-right="playlist_add_check") Odeslat ke schválení&nbsp;
              .float-right(v-else-if="item.metadata.submissionStatus === 'pending_approval'")
                q-btn(flat color="secondary" disable icon-right="hourglass_empty") Čeká na schválení&nbsp;
              .float-right(v-else-if="item.metadata.submissionStatus === 'submitted'")
                q-btn(flat color="secondary" disable icon-right="lock") Záznam uzamčen&nbsp;
              .q-pr-md
                q-separator
                .text-subtitle1(v-if="item && item.metadata.works !== undefined")
                  | {{ restaurators(item) }}
          .row.justify-center.wrap(v-if="item && item.metadata")
            .col-sm-12.col-md-9.q-pa-lg.q-pa-md-md.q-pa-sm-sm.q-pa-xs-xs
              q-card
                q-tabs(v-model="selectedTab"
                  dense
                  class="text-grey"
                  active-color="primary"
                  indicator-color="primary"
                  align="justify"
                  class="bg-grey-3 text-grey-7"
                  narrow-indicator)
                  q-route-tab(:to="{name: 'restorations-page-basic-info'}"  label="Informace o předmětu")
                  q-route-tab(:to="{name: 'restorations-page-materials'}"  label="Materiály a součásti")
                  q-route-tab(:to="{name: 'restorations-page-works'}" label="Restaurátorské zásahy")
                  q-route-tab(:to="{name: 'restorations-page-gallery'}" label="Galerie")

                .q-mt-md.q-mx-sm.q-py-md
                  router-view(:key="$route.name" transition-show="slideInLeft")

            .col-sm-12.col-md-3.q-pa-lg.q-pa-md-md.q-pa-sm-sm.q-pa-xs-xs
              q-card
                q-card-section
                  object-carousel(:item='item' :collectionCode="collectionCode")

</template>

<script>
import { Component, Vue } from 'vue-property-decorator'
import ObjectCarousel from './detail/ObjectCarousel'
import Navbar from '../../components/Navbar'
import KVPair from '../../components/KVPair'

export default @Component({
  meta: {
    title: '- Detail předmětu'
  },
  props: {
    collectionCode: String,
    itemId: [String, Number]
  },
  components: {
    'object-carousel': ObjectCarousel,
    'navbar': Navbar,
    'kv': KVPair
  }
})
class RestorationsPage extends Vue {
  selectedTab = 'basic-info'
  edit = false

  restaurators (item) {
    let res = ''
    if (item.metadata.works.length > 1) {
      item.metadata.works.forEach((work) => {
        res += work.metadata.creator + ', '
      })
      return 'Restaurovali ' + res.substring(0, res.length - 2)
    } else {
      return 'Restauroval(a) ' + item.metadata.works[0].metadata.creator
    }
  }

  requestReview (item) {
    this.$refs.oarepo.patch({ path: '/submissionStatus', op: 'replace', value: 'pending_approval' }).then((resp) => {
      this.notify$({ message: 'Zažádáno o schválení' })
      item.metadata.submissionStatus = 'pending_approval'
      this.$emit('save', resp.data.metadata)
    }).catch((err) => {
      console.error('Chyba při žádosti o schválení', err)
      this.notify$({ message: err })
    })
  }

  dataLoaded (item) {
    if (item.metadata.thumbnail && item.metadata.thumbnail.iiif) {
      this.$ui.setBackgroundUrl(`${item.metadata.thumbnail.iiif}full/400,/0/default.jpg`)
    } else {
      this.$ui.setBackgroundUrl(null)
    }
  }
}
</script>
<style lang="stylus" scoped>
.item-idlabel
  margin 0
  padding 0 1rem 0 0
.title-header
  text-shadow 0px 0px 7px rgba(255,255,255,0.3)
</style>
